export default {
  category: {
    isMultiple: true,
    delimiter: '/',
    icon: 'folder',
    order: 0
  },
  tags: {
    isMultiple: true,
    delimiter: ',',
    icon: 'tag',
    order: 1
  },
  price_min: {
    inRangeWith: {max: 'price_max'},
    icon: 'dollar',
    label: 'At least',
    format: value => `$${value}`,
    order: 2
  },
  price_max: {
    inRangeWith: {min: 'price_min'},
    icon: 'dollar',
    label: 'At most',
    format: value => `$${value}`,
    order: 3
  },
  length_min: {
    inRangeWith: {max: 'length_max'},
    icon: 'clock',
    label: 'At least'
  },
  length_max: {
    inRangeWith: {min: 'length_min'},
    icon: 'clock',
    label: 'At most'
  },
  sales: {
    isMultiple: false,
    icon: 'bar-chart',
    labels: {
      'rank-0': 'No sales',
      'rank-1': 'Low',
      'rank-2': 'Medium',
      'rank-3': 'High',
      'rank-4': 'Top Sellers'
    },
    order: 4
  },
  rating_min: {
    isMultiple: false,
    icon: 'star',
    labels: {
      '1': '1 star and higher',
      '2': '2 stars and higher',
      '3': '3 stars and higher',
      '4': '4 stars and higher'
    },
    order: 5
  },
  sort_by: {
    isMultiple: false,
    icon: 'sort',
    labels: {
      relevance: 'Best match',
      trending: 'Trending items',
      sales: 'Best sellers',
      rating: 'Best rated',
      date: 'Newest items',
      'price-asc': 'Price: low to high',
      'price-desc': 'Price: high to low'
    },
    order: 6
  },
  date: {
    isMultiple: false,
    icon: 'calendar',
    labels: {
      '': 'Any date',
      'this-year': 'In the last year',
      'this-month': 'In the last month',
      'this-week': 'In the last week',
      'this-day': 'In the last day'
    },
    order: 7
  },
  platform: {
    isMultiple: false,
    icon: 'code',
    delimiter: ' ',
    order: 8
  },
  compatible_with: {
    isMultiple: true,
    delimiter: ',',
    icon: 'code',
    order: 9
  },
  attribute_value: {
    isMultiple: false,
    icon: '',
    order: 10
  },
  poly_count: {
    isMultiple: false,
    icon: 'polygon',
    order: 11
  },
  file_formats: {
    isMultiple: true,
    isArrayFormat: true,
    delimiter: ',',
    icon: 'document',
    order: 12,
    labels: {
      obj: '.obj (multi format)',
      fbx: '.fbx (multi format)',
      max: '.max (3ds Max)',
      c4d: '.c4d (cinema 4d)',
      ma: '.ma (maya)',
      blend: '.blend (blender)',
      '3ds': '.3ds (multi format)',
      mb: '.mb (maya)',
      lwo: '.lwo (lightwave)',
      dxf: '.dxf (multi format)',
      dwg: '.dwg (AutoCAD)',
      lws: '.lws (lightwave)',
      '3b': '.3b (3dcoat)',
      unitypackage: '.unitypackage (Unity3D)',
      vob: '.vob (Vue)',
      vue: '.vue (Vue)',
      ztl: '.ztl (zbrush)',
      xsi: '.xsi (softimage)'
    }
  },
  orientation: {
    isMultiple: false,
    icon: 'frame-rotated',
    labels: {
      landscape: 'Landscape',
      portrait: 'Portrait',
      square: 'Square'
    },
    order: 13
  },
  colors: {
    isMultiple: true,
    delimiter: ',',
    icon: 'palette',
    order: 14
  },
  sizes: {
    isMultiple: true,
    delimiter: ',',
    icon: 'ruler',
    labels: {
      m: 'Medium',
      l: 'Large',
      xl: 'Extra large',
      xxl: 'Extra extra large'
    },
    order: 15
  },
  vocals_in_audio: {
    isMultiple: true,
    delimiter: ',',
    icon: 'vocals',
    isArrayFormat: true
  },
  tempo: {
    isMultiple: false,
    icon: 'tempo',
    labels: {
      'very-slow': 'Very slow (0 - 60 BPM)',
      slow: 'Slow (60 - 90 BPM)',
      medium: 'Medium (90 - 110 BPM)',
      upbeat: 'Upbeat (110 - 140 BPM)',
      fast: 'Fast (140 - 160 BPM)',
      'very-fast': 'Very fast (160+ BPM)'
    }
  },
  resolution_min: {
    isMultiple: false,
    icon: 'tv',
    labels: {
      '720p': '720p (HD)',
      '1080p': '1080p (Full HD)',
      '2K': '2K',
      '4K': '4K (UHD)'
    }
  },
  frame_rate: {
    isMultiple: false,
    icon: 'film',
    format: value => `${value} fps`
  },
  requires_plugins: {
    isMultiple: false,
    icon: 'plug',
    labels: {
      'F': 'No',
      'T': 'Yes'
    }
  },
  alpha: {
    isMultiple: false,
    isBoolean: true,
    icon: 'alpha'
  },
  looped: {
    isMultiple: false,
    isBoolean: true,
    icon: 'looped'
  }
}



// WEBPACK FOOTER //
// ./common/constants/filterParamsConfig.js